
import rzIconSun from '../../icons/icon-sun/index.vue';
import rzIconMoon from '../../icons/icon-moon/index.vue';

export default {
  name: 'rzThemeSwitcher',
  components: {
    rzIconSun, 
    rzIconMoon,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selected: 'light',
    };
  },
  computed: {
    currentIcon () {
      return this.selected === 'dark' ? 'rz-icon-moon' : 'rz-icon-sun';
    },
  },
  watch: {
    value: {
      handler(value) {
        this.selected = value;
      },
      immediate: true,
    },
  },
  methods: {
    switchTheme() {
      this.$emit('input', this.selected === 'dark' ? 'light' : 'dark');
    },
  },
};
